import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { TableBody } from '@material-ui/core';
import { BaseTableRow } from './BaseTableRow';
import { BaseTableCell } from './BaseTableCell';

type PBaseTableBody = {
  loading?: boolean;
};

export const BaseTableBody: React.FC<PBaseTableBody> = (props) => {
  const { loading, children } = props;

  const isNoDataVisible =
    (!children || (Array.isArray(children) && !children.length)) && !loading;

  return (
    <TableBody>
      {isNoDataVisible && (
        <BaseTableRow>
          <BaseTableCell colSpan={100} align="center">
            No data available
          </BaseTableCell>
        </BaseTableRow>
      )}
      {loading
        ? [1, 2, 3, 4, 5].map((el) => {
            return (
              <BaseTableRow key={el}>
                <BaseTableCell colSpan={100}>
                  <Skeleton height="27px" />
                </BaseTableCell>
              </BaseTableRow>
            );
          })
        : children}
    </TableBody>
  );
};
